import { render } from "./Orders.vue?vue&type=template&id=f800759a&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=f800759a&scoped=true&lang=scss"
import "./Orders.vue?vue&type=style&index=1&id=f800759a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f800759a"]])

export default __exports__